import {
  Box,
  CircularProgress,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { WITHDRAW_DEPOSIT_STATES } from "../../constants";

export function State({ data }) {
  const theme = useTheme();

  if (data.stateId === WITHDRAW_DEPOSIT_STATES.InProcessing.id) {
    return (
      <BoxState>
        <CircularProgress size="20px" color="inherit" />

        <Typography lineHeight={0} variant="h6" color="text.main">
          {data.state}
        </Typography>
      </BoxState>
    );
  }

  if (data.stateId === WITHDRAW_DEPOSIT_STATES.Canceled.id) {
    return (
      <BoxState color={theme.palette.error.main}>
        <ion-icon lineHeight={0} name="close-circle-outline" />

        <Typography color="error.main" variant="h6">
          {data.state}
        </Typography>
      </BoxState>
    );
  }

  if (data.stateId === WITHDRAW_DEPOSIT_STATES.Confirmed.id) {
    return (
      <BoxState color={theme.palette.success.main}>
        <ion-icon name="checkmark-circle-outline" />

        <Typography lineHeight={0} color="success.main" variant="h6">
          {data.state}
        </Typography>
      </BoxState>
    );
  }

  return (
    <BoxState>
      <Typography lineHeight={0} color="success.main" variant="h6">
        {data.state}
      </Typography>
    </BoxState>
  );
}
const BoxState = styled(Box)(({ theme, color }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.palette.text.secondary,
  ".MuiTypography-root": {
    marginLeft: theme.spacing(1),
  },

  "ion-icon": {
    width: "20px",
    height: "20px",
    color: color,
  },
}));

export default State;
